// extracted by mini-css-extract-plugin
export default {"grid_cols_custom":"ArtistAlbum_grid_cols_custom__3m3tZ"};